/**
 * @link https://stackoverflow.com/a/46455994/1847705
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'month' } )
export class MonthPipe implements PipeTransform {
    
    transform( pMonthId: number ): string {
        const months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
        return pMonthId == null ? null : months[ pMonthId - 1 ];
    }
}
